import router from '@/router'

let filters = [
    // 登录拦截
    function(response) {
        if (response.data && response.data.status && response.data.status == 2) {
            let reg = /share/;
            localStorage.removeItem("userinfo")
            localStorage.removeItem('sso_studioType')
            if (!reg.test(window.location.hash) && location.href.indexOf('login')<0) {
                router.replace('/login')
            }
        }
        return response;
    }
]


let filterFun = function(response) {
    let result = response;
    for (let index = 0; index < filters.length; index++) {
        const filter = filters[index];
        result = filter(response);
        if (result == null) {
            return result;
        }
    }
    return result;
}


export default filterFun;


// WEBPACK FOOTER //
// ./src/filtres/index.js